import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../shared.module';
import { GraphQLService } from 'src/app/services/graph-ql.service';
import { OrderQueries } from 'src/app/shared/types/get-query';
import { map } from 'rxjs';
import { MatSelectModule } from '@angular/material/select';
import { Status } from 'src/app/components/company/models/new/status';
import { Selectable } from '../../types/selectable.type';

@Component({
	selector: 'bt-change-order-status',
	standalone: true,
	imports: [MatDialogModule, MatIconModule, FormsModule, MatFormFieldModule, MatButtonModule, MatInputModule, MatSelectModule, CommonModule, SharedModule],
	templateUrl: './change-order-status.component.html',
	styleUrl: './change-order-status.component.scss'
})
export class ChangeOrderStatusComponent {
	readonly #dialogRef = inject(MatDialogRef<ChangeOrderStatusComponent>);
	readonly #graphQlService = inject(GraphQLService);
	readonly data = inject(MAT_DIALOG_DATA);

	datasource: Selectable<Status>[] = [];

	constructor() {}

	onClose(): void {
		this.#dialogRef.close();
	}

	selectStatus(status: Status): void {
		this.datasource = this.datasource.map((s) => ({
			...s,
			selected: s.id == status.id
		}));
	}

	ngOnInit(): void {
		this.#graphQlService
			.getData(OrderQueries.GET_ORDER_STATUSES, { first: 50 })
			.pipe(map((res: any) => res.data.orderStatus))
			.subscribe({
				next: (res) => {
					this.datasource = res.nodes.map((status: any) => ({
						...new Status({ id: status.id, name: status.name }),
						selected: false,
						disabled: status.id == this.data.currentStatus?.id
					}));
				}
			});
	}

	apply() {
		const selectedStatus = this.datasource.find((status) => status.selected);
		this.#dialogRef.close(selectedStatus);
	}
}
